// extracted by mini-css-extract-plugin
export default {"container":"DV-z","title":"EV-z","link":"FV-z"};